module.exports = __webpack_public_path__ + "img/fallback-slide.2560x1280.nl.dec792ae.png";